export const zipRegex = /^(\d{5})?$/;
export const cityRegex = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;